import { render, staticRenderFns } from "./exhibitionInfo.vue?vue&type=template&id=60d4173f&scoped=true&"
import script from "./exhibitionInfo.vue?vue&type=script&lang=js&"
export * from "./exhibitionInfo.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionInfo.vue?vue&type=style&index=0&id=60d4173f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4173f",
  null
  
)

export default component.exports